import type { SelectFieldChoices } from '@/src/Types/GF/Fields';

type SelectType = {
	placeholder?: string;
	name: string;
	id: string;
	autoComplete?: string;
	required: boolean;
	label: string;
	onChange: React.ChangeEventHandler<HTMLSelectElement>;
	htmlFor: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	description?: string | null;
	choices: SelectFieldChoices[];
};

export default function Select(props: SelectType) {
	const {
		placeholder,
		name,
		id,
		autoComplete,
		required,
		onChange,
		ariaLabel,
		disabled = false,
		className = '',
		description,
		choices,
	} = props;

	const inputTypeModel = {
		id: id,
		name: name,
		autoComplete: autoComplete,
		required: required,
		onChange: onChange,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
	};

	return (
		<div className={`relative h-12 w-full ${description ? 'mb-10' : 'mb-5'}`}>
			<select
				{...inputTypeModel}
				className={`peer minos-form-input-value-font-style relative size-full appearance-none rounded-minos-form-input border-minos-form-input-border-width border-minos-form-input-border-color bg-minos-form-input-bg-color px-4 text-base outline outline-0 transition-all tablet:minos-form-input-value-font-style focus:border-minos-form-input-border-width focus:border-minos-form-secondary-color focus:outline-0 disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100 ${className}`}
			>
				{placeholder && <option>{placeholder}</option>}

				{choices?.map((choice) => (
					<>
						<option className='p-2 text-base' key={choice?.value || ''} value={choice?.value || ''}>
							{choice?.text || ''}
						</option>
					</>
				))}
			</select>
			<div className='pointer-events-none absolute right-0 top-1/2 flex h-full -translate-y-1/2 items-center px-4 text-minos-form-input-color'>
				<svg
					width='14'
					height='9'
					viewBox='0 0 14 9'
					fill='currentColor'
					xmlns='http://www.w3.org/2000/svg'
					aria-hidden='true'
					className=''
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.00005 8.91421L0.292941 2.20711L1.70715 0.792894L7.00005 6.08579L12.2929 0.792895L13.7072 2.20711L7.00005 8.91421Z'
						fill='currentColor'
					/>
				</svg>
			</div>
		</div>
	);
}
